import { Injectable } from "@angular/core";
import { AudioPage } from "../audio-page/audio-page";
import { PowerPage } from "../power-page/power-page";
import { DisplayCameraPage } from '../display-camera-page/display-camera-page';


@Injectable({
	providedIn: 'root'
})

export class DeviceSettings {

	constructor(
		private powerPage: PowerPage,
		private audioPage: AudioPage,
		private displayCameraPage: DisplayCameraPage
	) {}

	private readonly pages = [
		this.powerPage,
		this.audioPage,
		this.displayCameraPage
	]

	public async isVisible() {
		const pagesVisibilities = await Promise.all(this.pages.map((page) => page.isVisible()));
		const isSomePageVisible = pagesVisibilities.some((visible) => visible);
		return isSomePageVisible;
	}
}
